import { Content } from "src/shared/components/content";

export const Safe = () => (
  <svg version="1.1" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
    <title>
      <Content id="cid$#2984764#" />
    </title>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-340 -292)">
        <g transform="translate(340 292)">
          <circle cx="100" cy="100" r="100" fill="#E8F4D9" />
          <g transform="translate(63 57)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4.1589">
            <path
              id="a"
              d="m56.25 8.9441c-7.5 0-14.25-3.354-18.75-8.9441-4.5 5.5901-11.25 8.9441-18.75 8.9441-6.75 0-12.75-2.6087-18.75-7.0807v46.16c0 5.9683 0.74755 12.051 4.2717 16.869 4.7717 6.5235 14.44 15.551 33.228 20.822 18.788-5.272 28.457-14.299 33.228-20.822 3.5241-4.818 4.2717-10.901 4.2717-16.869v-46.16c-6.375 4.472-12.375 7.0807-18.75 7.0807z"
              stroke="#264A19"
            />
            <polygon
              points="56.25 33.54 45 33.54 45 22.36 30 22.36 30 33.54 18.75 33.54 18.75 48.447 30 48.447 30 59.627 45 59.627 45 48.447 56.25 48.447"
              stroke="#8CC63F"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
